export const getPickPlatformViewStyle = () => ({
  container: {
    fontSize: '14px',
    marginLeft: 26,
    marginBottom: 12,
    maxWidth: 600,
    lineHeight: '24px',
    '& .ms-ChoiceField': {
      marginRight: '18px',
      marginBottom: 18,
      width: 130,
      height: 110,
    },
    '& label span[id^="ChoiceGroup"]': {
      fontWeight: 'bold',
    },
  },
  description: {
    marginBottom: 24,
  },
  surveyBlock: {
    display: 'flex',
    float: 'right',
  },

});
